import React from "react";
import "./css/loader.css";

const Loader = () => (
  <div
    data-quid="loader"
    className="chat__history__item chat__history__loader author--dpz"
  >
    <div className="container">
      <div className="dot" />
      <div className="dot" />
      <div className="dot" />
    </div>
    <div className="triangle" />
  </div>
);

export default Loader;
